import React from 'react';

interface SchemaMarkupProps {
  type: 'website' | 'organization' | 'faq' | 'service' | 'breadcrumb';
  data?: any;
}

const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ type, data }) => {
  const generateSchema = () => {
    switch (type) {
      case 'website':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "RadonMap Canada",
          "alternateName": "RadonMap.ca",
          "url": "https://radonmap.ca",
          "description": "Canada's comprehensive radon map and testing information resource",
          "publisher": {
            "@type": "Organization",
            "name": "RadonLab Network",
            "url": "https://radonlab.ca"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://radonmap.ca/?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };

      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "RadonLab Network",
          "alternateName": "RadonLab",
          "url": "https://radonlab.ca",
          "logo": "https://radonmap.ca/logo.png",
          "description": "Canada's Unified Radon Safety System - Testing, data, and mitigation simplified",
          "slogan": "Canada's Radon Science Authority",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-800-555-0123",
            "contactType": "customer service",
            "areaServed": "CA",
            "availableLanguage": ["English", "French"]
          },
          "areaServed": {
            "@type": "Country",
            "name": "Canada"
          },
          "serviceArea": {
            "@type": "Country",
            "name": "Canada"
          }
        };

      case 'faq':
        return {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What are safe radon levels in Canada?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Health Canada recommends remedial measures when radon levels exceed 200 Bq/m³ in indoor air. Levels below 100 Bq/m³ are considered low risk."
              }
            },
            {
              "@type": "Question",
              "name": "How long does radon testing take?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Long-term testing (3-12 months) provides the most accurate results. Short-term tests (2-7 days) can provide initial screening results."
              }
            },
            {
              "@type": "Question",
              "name": "Can radon be removed from homes?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, professional mitigation systems can effectively reduce radon levels. Sub-slab depressurization is the most common and effective method."
              }
            }
          ]
        };

      case 'service':
        return {
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Professional Radon Testing",
          "description": "Comprehensive radon testing services for Canadian homes and buildings",
          "provider": {
            "@type": "Organization",
            "name": "RadonLab Network"
          },
          "areaServed": {
            "@type": "Country",
            "name": "Canada"
          },
          "serviceType": "Radon Testing and Mitigation",
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceRange": "$149-$299"
          }
        };

      case 'breadcrumb':
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data || [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://radonmap.ca"
            }
          ]
        };

      default:
        return null;
    }
  };

  const schema = generateSchema();
  
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaMarkup;